import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#86EFAC]">{children}</p>
);

export const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: EASE }}
  >
    {children}
  </motion.main>
);

export const PageHeader = ({ eyebrow, title, copy }) => (
  <section className="relative overflow-hidden border-b border-white/10 px-6 pb-16 pt-36 sm:px-10 lg:px-16">
    <div className="pointer-events-none absolute -right-24 top-10 select-none font-display text-[16rem] font-black leading-none text-outline opacity-40">
      {eyebrow?.slice(0, 2)}
    </div>
    <div className="relative mx-auto max-w-6xl">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 max-w-3xl font-display text-4xl font-bold tracking-tight text-[#F6F4EE] sm:text-5xl lg:text-6xl">
          {title}
        </h1>
      </Reveal>
      {copy && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#F6F4EE]/70 sm:text-lg">{copy}</p>
        </Reveal>
      )}
    </div>
  </section>
);
